// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__hafGY","footer":"Services_footer__3BhqO"};